module.exports = __webpack_public_path__ + "img/logo.d2095307.png";